import type { AuthMe, LookupResponse, RequestDetail, RequestRow } from '../types';

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...(init?.headers ?? {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { error?: string }).error || `HTTP ${res.status}`);
  }
  return data as T;
}

export function login(password: string) {
  return req<{ ok: boolean }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ password }),
  });
}

export function logout() {
  return req<{ ok: boolean }>('/api/auth/logout', { method: 'POST' });
}

export function me() {
  return req<AuthMe>('/api/auth/me');
}

export function lookup(phone: string, opts?: { defaultRegion?: string; notify?: boolean }) {
  return req<LookupResponse>('/api/lookup', {
    method: 'POST',
    body: JSON.stringify({
      phone,
      defaultRegion: opts?.defaultRegion ?? 'US',
      notify: opts?.notify ?? false,
    }),
  });
}

export function listRequests(limit = 40) {
  return req<{ total: number; requests: RequestRow[] }>(`/api/requests?limit=${limit}`);
}

export function getRequest(id: string) {
  return req<RequestDetail>(`/api/requests/${encodeURIComponent(id)}`);
}

export function stats() {
  return req<{ total_requests: number; ok_requests: number; last_24h: number }>('/api/stats');
}

export function vapidPublicKey() {
  return req<{ publicKey: string | null }>('/api/push/vapid-public-key');
}

export function pushSubscribe(sub: PushSubscriptionJSON) {
  return req<{ ok: boolean }>('/api/push/subscribe', {
    method: 'POST',
    body: JSON.stringify(sub),
  });
}

export function pushUnsubscribe(endpoint: string) {
  return req<{ ok: boolean }>('/api/push/unsubscribe', {
    method: 'POST',
    body: JSON.stringify({ endpoint }),
  });
}
